import { useState } from "react";
import SideMenu from "../../components/admin/SideMenu";
import SummaryLists from "../../components/admin/lists/SummaryLists";
import SummaryEdit from "../../components/admin/edit/SummaryEdit";
import { useSummary } from "../../hooks/useSummary";
import { useResultPages } from "../../hooks/useResultPages";

const AdminSummary = () => {
  const [editUserId, setEditUserId] = useState<string | null>(null);

  const [isNew, setIsNew] = useState(false);

  const { summaries } = useSummary();
  const { resultPages } = useResultPages();

  const handleEditUser = (userId: string) => {
    setEditUserId(userId);
    setIsNew(false);
  };

  const handleCreateNew = () => {
    setEditUserId(null);
    setIsNew(true);
  };

  const handleBack = () => {
    setEditUserId(null);
    setIsNew(false);
  };

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          <h3>基本データ</h3>

          {!editUserId && !isNew && (
            <div className="list-header">
              <div className="header-button-area">
                <button className="new-btn" onClick={handleCreateNew}>
                  ＋ 新規登録
                </button>
              </div>
            </div>
          )}

          {editUserId || isNew ? (
            <SummaryEdit
              summaryId={editUserId ?? undefined}
              onBack={handleBack}
            />
          ) : (
            <SummaryLists
              resultPages={resultPages}
              summaries={summaries}
              onEdit={handleEditUser}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminSummary;
